import { useContext, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { 
    AppSpan, Button, CenterPopupContainer, CustomContainer, 
    FixedContainer, 
    FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle 
} from "src/style"
import { NewSubsidiaryLayout } from 'src/component';
import { FiChevronDown } from "react-icons/fi";
import { statesInNigeria } from "src/provider/config/constant";

export const NewSubsidiaryDetails: React.FC<any> = ({formData, setFormData, next, close}) => {
    const navigate = useNavigate()
    const {info: {selectedUser, subsidiaryCreationProcess}, setInfoProperty} = useContext(AppInfoContext)

    useEffect(() => {
        if (selectedUser) {
            const {
                name, website, phoneNumber, 
                email, dateOfIncorporation, address,
                city, state
            } = selectedUser
            setFormData({
                ...formData, name, website, 
                phoneNumber, email, dateOfIncorporation, 
                address, city, state
            }) 
        }
    }, [selectedUser])

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => setFormData({...formData, [e.target.name]: e.target.value})

    async function handleNext(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        await setInfoProperty('subsidiaryCreationProcess', {...subsidiaryCreationProcess, details: true})
        
        next()
    }
    
    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewSubsidiaryLayout currentScreen='details'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Set Up basics for the User
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    <Form topMargin='3' onSubmit={handleNext}>
                        <FormGroup>
                            <label>Subsidiary Name</label>
                            <input 
                                placeholder='Enter Subsidiary Name' 
                                name='name'
                                value={formData.name}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <FormGroup >
                            <label>Email</label>
                            <input 
                                placeholder='Enter Email' 
                                name='email'
                                type='email'
                                value={formData.email}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        {/* <FlexRow 
                            gap='1.5'
                            alignItems="flex-end"
                            className='user-basic-input-row'
                        >
                            <FormGroup bottomMargin='0'>
                                <label>Phone Number</label>
                                <input 
                                    placeholder='Enter Phone Number' 
                                    name='phoneNumber'
                                    value={input.phoneNumber}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    //required
                                />
                            </FormGroup>
                            <AppSpan 
                                textSize="1.6" color="#5627FF" 
                                hoverColor="#4F4F4F" bottomMargin="1" 
                                cursor="pointer"
                            >
                                Add new phone number
                            </AppSpan>
                        </FlexRow> */}
                        <FormGroup>
                            <label>Phone Number</label>
                            <input 
                                placeholder='Enter Phone Number' 
                                name='phoneNumber'
                                value={formData.phoneNumber}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Official Website</label>
                            <input 
                                placeholder='Enter Official Website' 
                                name='website'
                                value={formData.website}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <label>Date Of Incorporation</label>
                            <input 
                                placeholder='Enter Date Of Incorporation' 
                                name='dateOfIncorporation'
                                type='date'
                                value={formData.dateOfIncorporation}
                                onChange={handleInput}
                                autoComplete="off"
                                required
                            />
                        </FormGroup>
                        <CustomContainer topMargin="3.5">
                            <ScreenTitle 
                                textSize="1.6" 
                                fontWeight="700" 
                                color="#282828"
                            >
                                Office Location
                            </ScreenTitle>
                            <CustomContainer topMargin="2">
                                <FormGroup>
                                    <label>Office Address</label>
                                    <input 
                                        placeholder='Enter Office Address' 
                                        name='address'
                                        value={formData.address}
                                        onChange={handleInput}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                <FlexRow 
                                    justifyContent='space-between' gap='2'
                                    className='user-basic-input-row'
                                >
                                    <FormGroup bottomMargin="0">
                                        <label>City</label>
                                        <input 
                                            placeholder='Enter City' 
                                            name='city'
                                            value={formData.city}
                                            onChange={handleInput}
                                            autoComplete="off"
                                            required
                                        />
                                    </FormGroup>
                                    <FormGroupWithIcon bottomMargin="0">
                                        <label>State</label>
                                        <div 
                                            style={{height: '5.5rem'}}
                                            className="input-with-icon"
                                        >
                                            <select 
                                                name='state'
                                                value={formData.state}
                                                onChange={handleInput}
                                                style={{height: '5.5rem'}}
                                                autoComplete='off'
                                            >
                                                <option value="">Select State</option>
                                                {
                                                    statesInNigeria.map((state, index) => {
                                                        return (
                                                            <option value={state} key={index}>{state}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                </FlexRow>
                                <FlexRow 
                                    justifyContent='space-between' gap='2'
                                    className='user-basic-input-row'
                                >
                                    {/* <FormGroupWithIcon bottomMargin='0'>
                                        <label>Country</label>
                                        <div 
                                            style={{height: '5.5rem'}}
                                            className="input-with-icon"
                                        >
                                            <select 
                                                name='country'
                                                value={formData.country}
                                                onChange={handleInput}
                                                style={{height: '5.5rem'}}
                                                autoComplete='off'
                                            >
                                                <option value="">Select Country</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="Canada">Canada</option>
                                                <option value="France">France</option>
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon> */}
                                </FlexRow>
                            </CustomContainer>
                        </CustomContainer>

                        <FlexRow 
                            justifyContent='flex-end' gap="1"
                            topMargin='5'
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={close}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                            >
                                Next
                            </Button>
                        </FlexRow>
                    </Form>
                </NewSubsidiaryLayout>
            </FixedContainer>
        </>
    )
}
